<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <a @click="$router.go(-1)" class="back-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
            <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
              <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000"
                stroke-width="2" />
              <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15"
                transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
            </g>
          </svg>
        </a>
        <a href="" class="link-title">Broker Details</a>
      </nav>
    </div>

    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="row">
          <!-- Enquiry Card -->
          <div class="col-12">
            <div class="card details-card">
              <div class="card-header">
                <div class="row">
                  <div class="col-7">
                    <span class="lead-title" v-if="GetBrokerDetails.broker_name">{{GetBrokerDetails.broker_name}}</span>
                    <span class="sub-title" v-if="GetBrokerDetails.firm_name">{{GetBrokerDetails.firm_name}}</span>
                  </div>
                  <div class="col-5 text-right" v-if="GetBrokerDetails.status">
                    <span class="label-status">{{GetBrokerDetails.status}}</span>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-6" v-if="GetBrokerDetails.assigned_to">
                    <span class="enq-title">Assigned to</span>
                    <span class="enq-details">{{GetBrokerDetails.assigned_to}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.broker_locality">
                    <span class="enq-title">Locality</span>
                    <span class="enq-details">{{GetBrokerDetails.broker_locality}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.field_executive">
                    <span class="enq-title">Field Ex.</span>
                    <span class="enq-details">{{GetBrokerDetails.field_executive}} - {{GetBrokerDetails.broker_locality}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.performance">
                    <span class="enq-title">Performance</span>
                    <span class="enq-details">{{GetBrokerDetails.performance}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.cp_meeting">
                    <span class="enq-title">CP Meet</span>
                    <span class="enq-details">{{GetBrokerDetails.cp_meeting}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.ncd">
                    <span class="enq-title">NCD</span>
                    <span class="enq-details">{{GetBrokerDetails.ncd}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.site_visit_status">
                    <span class="enq-title">Site Visit Status</span>
                    <span class="enq-details">{{GetBrokerDetails.site_visit_status}}</span>
                  </div>
                  <div class="col-12" v-if="GetBrokerDetails.comment">
                    <span class="enq-title">Comment</span>
                     <read-more more-str="read more"  :text="GetBrokerDetails.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                  </div>
                  <div class="col-12" v-if="GetBrokerDetails.comment_history">
                    <span class="enq-title">Comment History</span>
                     <read-more more-str="read more"  :text="GetBrokerDetails.comment_history" link="#" less-str="read less" :max-chars="50"></read-more>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col-6 text-center">
                    <a v-if="GetBrokerDetails.contact_number" :href="`tel:${GetBrokerDetails.contact_number}`">
                    <span class="icon icon-call">
                      <img src="@/assets/phone.svg" alt="" />
                    </span>
                    <span class="enq-title">Mobile Number</span>
                    <span class="enq-details">{{GetBrokerDetails.contact_number}}</span>
                    </a>
                  </div>
                  <div class="col-6 text-center">
                    <a v-if="GetBrokerDetails.email" :href="`mailto:${GetBrokerDetails.email}`">
                    <span class="icon icon-call">
                      <img src="@/assets/email.svg" alt="" />
                    </span>
                    <span class="enq-title">Primary Email</span>
                    <span class="enq-details">{{GetBrokerDetails.email}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-btn">
              <div class="row">
                <div class="col-6 pr-2">
                  <router-link class="btn btn-white btn-block" :class="GetBrokerDetails.total_campaign===0 ? 'disabled' : ''" :to="{ name: 'ManageCampaign', params: { id: queryP.id, building_broker_id: GetBrokerDetails.building_broker_id }}">
                    <img src="@/assets/right-arrow.svg" alt="" class="right-arrow">
                    <span class="enq-title">Total Campaigns</span>
                    <span class="enq-details text-link">{{GetBrokerDetails.total_campaign}}</span>
                  </router-link>
                </div>
                <div class="col-6 pl-2">
                  <b-btn class="btn btn-white btn-block" @click="HideShowBrokers = true">
                    <span class="center-fix">
                      <img src="@/assets/edit-orange.svg" alt="" class="mr-1\" />Edit
                    </span>
                  </b-btn>
                </div>
                <div class="col-12 mt-3 mb-3">
                  <router-link :to="{ name: 'AddCampaign', params: { id: GetBrokerDetails.building_id, broker_id:GetBrokerDetails.broker_id,  building_broker_id: GetBrokerDetails.building_broker_id }}" class="btn btn-primary btn-block"> <img
                      src="@/assets/plus.svg" alt="" class="m-fix mr-1" /> Add
                    Campaign</router-link>
                </div>
              </div>
            </div>
            <vue-bottom-dialog v-model="HideShowBrokers" :height="570">
              <div class="card form-card p-0">
                  <div class="card-body pt-0 pb-0">
                      <div class="row">
                          <div class="col-8">
                              <span class="title-bottom">Update</span>
                          </div>
                          <div class="col-4 text-right">
                              <span class="title-bottom title-cancel"  @click="UpdateBrokerDetails = {}, HideShowBrokers = false">Cancel</span>
                          </div>
                      </div>
                      <b-form class="pb-0" @submit.prevent="UpdateBroker">
                          <b-form-group>
                              <label>NCD<span class="text-danger">*</span></label>
                              <datetime type="date" v-model="UpdateBrokerDetails.next_call_date" required placeholder="Next Call Date">
                              </datetime>
                          </b-form-group>
                          <b-form-group>
                            <label>Select Status<span class="text-danger">*</span></label>
                              <b-form-select v-model="UpdateBrokerDetails.status_id" :options="statusList" required></b-form-select>
                          </b-form-group>
                          <b-form-group>
                              <label>Select Performance<span class="text-danger">*</span></label>
                              <b-form-select v-model="UpdateBrokerDetails.performance" :options="performanceList" required></b-form-select>
                          </b-form-group>
                          <b-form-group>
                            <label>Comment<span class="text-danger">*</span></label>
                              <b-form-textarea placeholder="Add Comment" v-model="UpdateBrokerDetails.executive_comments" required rows="3" max-rows="5"></b-form-textarea>
                          </b-form-group>
                          <b-form-group class="mt-2">
                              <b-button variant="primary" type="submit" block>Save</b-button>
                          </b-form-group>
                      </b-form>
                  </div>
              </div>
          </vue-bottom-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
export default {
name: "BrokerDetails",
components: {
  datetime: Datetime
},
data() {
  return {
    GetBrokerDetails: {},
    queryP: {},
    HideShowBrokers: false,
    UpdateBrokerDetails: {
      status_id: null,
      performance: null,
      next_call_date: null,
      executive_comments: null,
    },
  };
},
mounted() {
  this.FetchBrokerInitiationDetails()
},
computed: {
  statusList() {
    return this.$store.getters.BuildingBrokerStatus;
  },
  performanceList() {
    return this.$store.getters.Performance;
  }
},
methods: {
  FetchBrokerInitiationDetails() {
    this.queryP['id'] = this.$route.params.id;
    this.queryP['broker_id'] = this.$route.params.brokerid;
    let searchDataUrl = new URLSearchParams({
        broker_id: this.queryP.broker_id
      }).toString();
    this.$axios.get(`/buildings/interested_brokers_detail?${searchDataUrl}`).then((res) => {
      this.GetBrokerDetails = JSON.parse(JSON.stringify(res.data).substring(1, JSON.stringify(res.data).length-1));
      if (this.GetBrokerDetails.comment !== null) {
        this.GetBrokerDetails.comment = this.GetBrokerDetails.comment.replaceAll('\n', '<br>')
      }
      if (this.GetBrokerDetails.comment_history !== null) {
        this.GetBrokerDetails.comment_history = this.GetBrokerDetails.comment_history.replaceAll('\n', '<br>')
      }
    });
    },
    UpdateBroker () {
      let queryParams = {}
      queryParams['building_broker_id'] = this.GetBrokerDetails.building_broker_id;
      this.$axios
      .put(`buildings/update_building_broker`,{ building_broker: this.UpdateBrokerDetails}, { params: queryParams })
      .then((res) => {
        swal({
          title: "Broker Details Updated!",
          icon: "success",
        }).then(this.UpdateBrokerDetails = {}, this.FetchBrokerInitiationDetails(), this.HideShowBrokers = false);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          swal({
            title: "Server Error!",
            icon: "error",
          });
        } else {
          swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error",
          });
        }
      });
    }
  }
};
</script>
<style scoped>
  .inner-page {
    margin-top: 60px;
  }
  .btn-secondary:hover {
    color: #233445;
    background-color: white;
    border-color: white;
}
</style>